import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import { hashHistory, Link } from 'react-router';
import {Modal} from 'antd';

export default class StudentAttendanceRecognitionIndexPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    let role = CurrentRoleStore.getCurrentRole();
    this.state = {
      role,
      grades: [],
      schoolId: props.params.schoolId,
      info: "",
      graduatedArray: [],
      showGraduated: false
    };
    // bind this
    this.toClassDetail = this.toClassDetail.bind(this);
  }

  componentDidMount() {
    CurrentRoleStore.addChangeListener(this.onRolesChange);
    if (this.state.role.associatName == 'classRecord') {
      hashHistory.push(`student-attendance/schools/${this.state.schoolId}/attendance-recognition/classes/${this.state.role.associatObj.id}`);
    }

    let data = {
      school_id: this.state.schoolId,
    }
    this.loadClasses(data);
  }

  componentWillUnmount() {
    CurrentRoleStore.removeChangeListener(this.onRolesChange);
  }

  loadClasses(data) {
    let that = this;
    DataService.getClassesRecognition(data).then((grades) => {
      this.setState({
        grades
      })
    }).catch((error) => {
      console.log(error);
    });
  }

  toolGraduatedDate(date) {
    return date ? (new Date(date).getFullYear() + '年') : ''
  }

  toClassDetail(e) {
    let classId = e.currentTarget.dataset.id;
    let className = e.currentTarget.dataset.classname;
    hashHistory.push(`student-attendance/schools/${this.state.schoolId}/attendance-recognition/classes/${classId}?className=${className}`);
  }

  render() {
    return ( 
      <div className="albums-manage-page">
        {/* <span className='upload-btn' onClick={()=>{DataService.createGatePassDistributionStudent(this.state.schoolId)
                    .then(res=>  Modal.success({
                      title: '下发成功',
                    }))
                    .catch(error=>Modal.error({
                      title: '下发失败！',
                      content: '请检查您的网络情况',
                    }))
                    }}>下发学生数据到刷卡机</span> */}
        <div className="classes-wrapper">
          {this.state.grades.map(grade =>
            <div key={grade.grade_id} style={{ marginBottom: '40px' }}>
              <div className="class-grade">{grade.grade_name}</div>
              {grade.class_records.map(classItem =>
                <div className="class-box" key={classItem.class_id} data-id={classItem.class_id} data-className={classItem.class_name} onClick={this.toClassDetail}>
                  <div className="class-box-name" >{classItem.class_name}</div>
                  <div className="class-box-info" >{classItem.student_count - classItem.set_count}人未上传</div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/attendance/StudentAttendanceRecognitionIndexPage.jsx